import { createReducer } from '../commons/js/utils/reducer';

const initialState = {
    currentPage: 1,
    pageCount: 1,
}

export const ffDashboardReducer = createReducer(initialState, {
    "SET_TOTAL_PAGES_COUNT": (state, action) => {
        return {
            ...state,
            pageCount: action.payload.value,
        }
    },
    "SET_CURRENT_PAGE": (state, action) => {
        return {
            ...state,
            currentPage: action.payload.value,
        }
    },
});

export default ffDashboardReducer;